import React from "react";
import { Box, Typography } from "@mui/material";
function TitleForm({ props }) {
  const { text } = props;
  return (
    <Box
      sx={(theme) => ({
        color: theme.palette.primaryText.main,
        borderBottom: "1px solid #00000020",
        width: "100%",
        py: 1,
        px: 2,
        boxSizing: "border-box",
      })}
    >
      <Typography sx={(theme) => ({ fontFamily: "Kanit", fontSize: 16 })}>
        {text}
      </Typography>
    </Box>
  );
}

export default TitleForm;
